import { render, staticRenderFns } from "./EventReplyManagement.vue?vue&type=template&id=2cb113b5&scoped=true"
import script from "./EventReplyManagement.vue?vue&type=script&lang=js"
export * from "./EventReplyManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb113b5",
  null
  
)

export default component.exports